import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { defineMessages, useIntl } from 'react-intl';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
// import { expandToBackendURL } from '@plone/volto/helpers/Url/Url';
import { Container } from '@plone/components';
import {
  expandToBackendURL,
  flattenToAppURL,
} from '@plone/volto/helpers/Url/Url';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import saveSVG from '@plone/volto/icons/save.svg';
import { getPersonFunctions, setPersonFunction } from '../../../actions';
import { Modal, Button, TextField } from '@plone/components';

const messages = defineMessages({
  commembers: {
    id: 'commembers',
    defaultMessage: 'Kommissionsmitglieder',
  },
  members: {
    id: 'members',
    defaultMessage: 'Akademiemitglieder',
  },
  otherPersons: {
    id: 'otherPersons',
    defaultMessage: 'Weitere Fachgelehrte',
  },
  func: {
    id: 'func',
    defaultMessage: 'Type in a function',
  },
  send: {
    id: 'send',
    defaultMessage: 'Save function',
  },
  change: {
    id: 'change',
    defaultMessage: 'Change function',
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel',
  },
});

const PersonFunctionModal = (props) => {
  const { person, content_id, onSave } = props;
  const [functionValue, setFunctionValue] = useState(person.function || '');
  const [openModal, setOpenModal] = useState(false);
  const intl = useIntl();

  return (
    <span>
      <Button
        type="button"
        basic
        className="button"
        onClick={() => {
          setOpenModal(true);
        }}
      >
        {intl.formatMessage(messages.change)}
      </Button>
      <Modal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        size="small"
        showCloseIcon={true}
      >
        <div>{person.title}</div>
        <TextField
          id={`function-${content_id}-${person['@id']}`}
          value={functionValue}
          placeholder={intl.formatMessage(messages.func)}
          onChange={(value) => {
            setFunctionValue(value);
          }}
        />
        <Button
          type="button"
          basic
          icon
          className="button"
          onClick={() => {
            onSave(functionValue, person, content_id);
            setOpenModal(false);
          }}
          aria-label={intl.formatMessage(messages.send)}
        >
          <Icon name={saveSVG} />
        </Button>
        <Button
          type="button"
          basic
          className="button"
          onClick={() => {
            setOpenModal(false);
          }}
          aria-label={intl.formatMessage(messages.cancel)}
        >
          {intl.formatMessage(messages.cancel)}
        </Button>
      </Modal>
    </span>
  );
};

const ProjectGroup = ({
  title,
  persons,
  onSave,
  editable,
  getPersonFunction,
  content_id,
}) => {
  const user_logged_in = useSelector((state) => state.userSession?.token);
  return (
    <Container className="details-container" key={content_id}>
      <div className="content-container">
        <div className="projectgroup-details">
          <div className="projectgroup-title">
            <h4 className="projectgroup-heading">
              {title ? (
                title
              ) : (
                <FormattedMessage
                  id="project.group"
                  defaultMessage="Projektgruppe"
                />
              )}
            </h4>
          </div>
          <div className="projectgroup-detail">
            <ul>
              {persons.map((person, index) => (
                <li key={person['@id']} className="person">
                  <div>
                    <ConditionalLink
                      href={person['@id']}
                      className={` ${person.review_state}`}
                      condition={!editable}
                    >
                      {person.title}
                    </ConditionalLink>
                    <span>
                      {' '}
                      {getPersonFunction(content_id, person['@id'])}{' '}
                    </span>
                    {!editable && user_logged_in && (
                      <PersonFunctionModal
                        key={person['@id']}
                        person={person}
                        content_id={content_id}
                        onSave={onSave}
                      />
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Container>
  );
};

const ProjectGroupView = (props) => {
  const { content, metadata, grouptitle, data, editable } = props;
  const subtype = data?.type || 'projectgroup';
  const overridenTitle = data?.title;
  const intl = useIntl();
  const personfunctions = useSelector(
    (store) => store.personfunction.subrequests,
  );
  const contentObject = metadata || content || {};
  const dispatch = useDispatch();
  const iterPersons = (contextId) => {
    if (personfunctions?.[contextId]?.loaded) {
      return (personfunctions?.[contextId]?.items || []).concat(
        ((contentObject['@id'] === contextId && content?.persons) || []).filter(
          (p) =>
            !(personfunctions?.[contextId]?.items || []).some(
              (i) => i?.['@id'] === p?.['@id'],
            ),
        ),
      );
    } else return contentObject?.persons || [];
  };
  const iterMembers = (contextId) => {
    return iterPersons(contextId).filter((person) =>
      person?.taxonomy_person_type.includes('h607ooqiq3'),
    );
  };
  const iterOtherPersons = (contextId) => {
    return iterPersons(contextId).filter(
      (person) => !person?.taxonomy_person_type.includes('h607ooqiq3'),
    );
  };

  const workgroups =
    contentObject?.items?.filter(
      (item) => item['@type'] === 'saw.persons.workgroup',
    ) || [];
  let ids = [];

  if (subtype !== 'projectgroup') {
    workgroups.forEach((workgroup) => {
      ids.push(workgroup['@id']);
    });
  } else {
    ids = [contentObject['@id']];
  }

  let hasPersons = true;

  const getPersonFunction = (contextId, personId) => {
    let func = '';
    if (personfunctions?.[contextId]?.loaded) {
      const person = personfunctions?.[contextId]?.items.find((person) => {
        return person['@id'] === personId;
      });
      func = person?.function || '';
    }
    return func;
  };

  const onSave = (value, person, content_id) => {
    if (value === getPersonFunction(content_id, person['@id'])) {
      return;
    }
    dispatch(
      setPersonFunction(
        expandToBackendURL(content_id),
        flattenToAppURL(person['@id']),
        value,
        content_id,
      ),
    );
  };

  React.useEffect(() => {
    if (ids) {
      ids.forEach((id) => {
        if (id) {
          dispatch(getPersonFunctions(expandToBackendURL(id), id));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids.join(','), content?.persons?.length]);

  return (
    <div className="block projectgroup ">
      {ids.map((id) => {
        let title = overridenTitle;
        if (subtype !== 'projectgroup') {
          // const title = workgroups?.find((wg) => wg['@id'] === id)?.title;
          title =
            overridenTitle ||
            grouptitle ||
            workgroups?.find((wg) => wg['@id'] === id)?.title;
          hasPersons = personfunctions?.[id]?.items?.length > 0;
        } else {
          hasPersons =
            contentObject?.persons?.length > 0 || content?.persons?.length > 0;
          // if project is a kommission split persons into members and others, else show all together.
          // This is because for kommissionen we want to highlight the members more and show the rest as additional info,
          // while for other groups we dont want this distinction
          const isCommission = (contentObject?.taxonomy_project_type || [])
            .map((ptype) => {
              return typeof ptype === 'string' ? ptype : ptype.token;
            })
            .includes('b207nuqiq2');
          if (isCommission) {
            return (
              hasPersons && (
                <React.Fragment key={id}>
                  <h3 key={id}> {intl.formatMessage(messages.commembers)} </h3>
                  {iterMembers(id).length > 0 && (
                    <ProjectGroup
                      title={intl.formatMessage(messages.members)}
                      persons={iterMembers(id)}
                      onSave={onSave}
                      editable={editable}
                      getPersonFunction={getPersonFunction}
                      content_id={id}
                      key="members"
                    ></ProjectGroup>
                  )}
                  {iterOtherPersons(id).length > 0 && (
                    <ProjectGroup
                      title={intl.formatMessage(messages.otherPersons)}
                      persons={iterOtherPersons(id)}
                      onSave={onSave}
                      editable={editable}
                      getPersonFunction={getPersonFunction}
                      content_id={id}
                      key="others"
                    ></ProjectGroup>
                  )}
                </React.Fragment>
              )
            );
          }
        }
        return (
          hasPersons && (
            <ProjectGroup
              title={title}
              persons={iterPersons(id)}
              onSave={onSave}
              editable={editable}
              getPersonFunction={getPersonFunction}
              content_id={id}
            ></ProjectGroup>
          )
        );
      })}
    </div>
  );
};

export default ProjectGroupView;
